/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getBlob.defs.js'
export { main as default } from './getBlob.defs.js'
